/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {MutationPayload} from 'vuex';

/**
 * Local storage subscriber that versions and stores registered module state.
 * @param {MutationPayload} mutation
 * @param rootState
 */
export default (mutation: MutationPayload, rootState: any): void => {
    // check mutation type format
    if (!mutation.type.match(/(.+module)\/(.+)/i)) {
        return;
    }

    // Get module and action
    const module: string = mutation.type.replace(/(.+module)\/(.+)/i, '$1');
    const action: string = mutation.type.replace(/(.+module)\/(.+)/i, '$2');

    // check for mutation support
    switch (module) {
        case 'userSessionModule':
            if (!['authenticate', 'logout'].includes(action)) {
                return;
            }
            break;
        case 'settingsModule':
            if (!['updateLanguage'].includes(action)) {
                return;
            }
            break;
        default:
            return;
    }

    // update state
    localStorage.setItem(`planet-zoo/store/${module}/version`, rootState.version);
    localStorage.setItem(`planet-zoo/store/${module}`, JSON.stringify(rootState[module]));
};
